import {useRouteParams} from '@vueuse/router';

export default function useMonadicRouteParam(name: string) {
	const param = useRouteParams(name);

	return computed({
		get(): string | null {
			return param.value === null
				? null
				: typeof param.value === 'string'
					? param.value
					: param.value[0];
		},
		set(value: string | null) {
			if (param.value !== value) {
				param.value = value;
			}
		},
	});
}
